import { Component, EventEmitter, Input, OnInit, Output, NgModule, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { CASINO_LOBBY_GAMES } from '@environments/environment';

@Component({
  selector: 'casinobslobby-component',
  templateUrl: '../sharedTemplates/casinobslobby-component.html',
})
export class CasinoBSLobbyComponent implements AfterViewInit {
  casinoList = [];

  selectedCasinoType = 0;

  gameTypes;

  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router
  ) {}

  getCasinoGames() {
    this._ApiService.getCasinoBSGames().then(x => {
      ////console.warn(x);
      this.gameTypes = x;
    });
  }

  goGames(item) {
    this._router.navigate(['casinobs/' + item.GameId + '/' + item.ProductId]);
  }

  ngAfterViewInit() {
    if (this._UiHelper.leftMenu) this._UiHelper.setLeftMenu();

    this._UiHelper.setNavbarTitle('Casino', true);
    this.getCasinoGames();
  }
}
